(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function parseEndDate(value) {
    if (!value) return null;
    var parsed = new Date(value).getTime();
    return Number.isNaN(parsed) ? null : parsed;
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-offer-countdown]');
    if (!countdown) return;

    var target = parseEndDate(countdown.getAttribute('data-end-date'));
    if (!target) return;

    var daysEl = countdown.querySelector('[data-offer-days]');
    var hoursEl = countdown.querySelector('[data-offer-hours]');
    var minutesEl = countdown.querySelector('[data-offer-minutes]');
    var secondsEl = countdown.querySelector('[data-offer-seconds]');

    function tick() {
      var distance = target - Date.now();
      if (distance <= 0) {
        countdown.classList.add('is-expired');
        return false;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
      return true;
    }

    if (!tick()) return;
    var timer = window.setInterval(function () {
      if (!tick()) window.clearInterval(timer);
    }, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-offer-collection]').forEach(function (root) {
      if (root.dataset.offerReady === 'true') return;
      root.dataset.offerReady = 'true';
      initCountdown(root);
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
